module.exports = __webpack_public_path__ + "img/password-updated.04ffe410.jpg";